import React from 'react';
export function Footer() {
  return <footer className="w-full bg-navy-deep" data-id="element-95" data-mp="32wd2qgad7ltj">
      <div className="max-w-3xl mx-auto px-5 py-12 text-center" data-id="element-96" data-mp="3gezeh7brdx2q">
        <h3 className="font-display text-2xl uppercase tracking-wide text-gold" data-id="element-97" data-mp="3ghc2o28413o8">The Parkour Class-Ready Megapack</h3>
        <p className="mx-auto mt-2 max-w-md text-sm text-white/70" data-id="element-98" data-mp="36pfs3rou7l34">
          The Ready-Run Session System — because no parkour class should start
          with a blank page.
        </p>

        <div className="mt-5 flex flex-wrap justify-center gap-x-5 gap-y-1 text-[13px] text-white/70" data-id="element-99" data-mp="3ud7g3sjqpmk8">
          <a href="mailto:help@iclcollective.com" className="inline-flex min-h-[44px] items-center px-1 hover:text-white hover:underline" data-id="element-100" data-mp="36d26u3xsnlq">
            help@iclcollective.com
          </a>
        </div>

        <p className="mx-auto mt-7 max-w-2xl border-t border-navy-line pt-5 text-xs leading-relaxed text-white/45" data-id="element-101" data-mp="29yxcxcohlklt">
          The Parkour Class-Ready Megapack is a class-planning resource for parkour
          coaches and instructors. It does not replace a coaching qualification,
          first-aid training, insurance, risk assessment of your space or your
          organisation&apos;s safety policies. Parkour involves physical risk;
          coaches are responsible for supervising their students and adapting every
          session to their group, space and local regulations. Results depend on
          the coach and the group; no specific outcome is guaranteed. © The Parkour
          Class-Ready Megapack 2026 — All rights reserved.
        </p>
      </div>
    </footer>;
}